export default {"src":"/_next/static/media/hassle-free.eb0427d5.svg","height":39,"width":35};